window.addEventListener('DOMContentLoaded', function () {
  const Swiper = window.Swiper;
  const carousel = document.querySelector('.featured-products-carousel');

  if (carousel) {
    new Swiper('.featured-products-carousel', {
      slidesPerView: 1,
      spaceBetween: 20,
      slidesPerGroup: 1,

      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
        },
        960: {
          slidesPerView: 3.6,
          slidesPerGroup: 3,
        },
        1400: {
          slidesPerView: 4.9,
          slidesPerGroup: 4,
        },
      },

      pagination: {
        el: '.featured-products-carousel-pagination .swiper-pagination',
        clickable: true,
      },
    });
  }
});
